import React from "react";
import { RouteProps, Switch } from "react-router";
import { Route } from "react-router-dom";
import * as Comp from "../components";
import { Paths } from "../constants";
import * as Cont from "../containers";

const adminRoutes = <Switch>
    {/*** Admin routes ***/}

    {/* Admin landing */}
    <Comp.Access.AdminRoute exact path={Paths.Admin.Landing} render={(routeProps) => <Cont.Admin.Landing /> } />

    {/* Admin abstracts */}
    <Comp.Access.AdminRoute path={Paths.AdminAbstracts.BasePath + "/:eventId"} component={Cont.AdminAbstracts.AdminAbstractsRoutes} />

    {/* Admin email templates */}
    <Comp.Access.AdminRoute exact path={Paths.AdminEmailTemplate.List} component={Cont.AdminEmailTemplates.ListEmailTemplates} />
    <Comp.Access.AdminRoute exact path={Paths.AdminEmailTemplate.Edit + "/:id"} component={Cont.AdminEmailTemplates.Edit} />

    {/* Admin events */}
    <Comp.Access.AdminRoute exact path={Paths.AdminEvent.List} component={Cont.AdminEvent.ListEvents} />
    <Comp.Access.AdminRoute exact path={Paths.AdminEvent.Edit + "/:id"} component={Cont.AdminEvent.Edit} />
    <Comp.Access.AdminRoute exact path={Paths.AdminEvent.Edit + "/:id/calendar"} component={Cont.AdminEvent.EditCalendar} />

    {/* Admin navigation */}
    <Comp.Access.AdminRoute path={Paths.AdminNav.SortItems + "/:itemId"} render={(routeProps) => <Cont.AdminNav.SortItems { ...routeProps } /> } />
    <Comp.Access.AdminRoute path={Paths.AdminNav.List + "/:action?/:itemId?"} render={(routeProps) => <Cont.AdminNav.ListView { ...routeProps } /> } />

    {/* Admin pages */}
    <Comp.Access.AdminRoute path={Paths.AdminPage.List} render={(routeProps) => <Cont.AdminPage.ListView { ...routeProps } /> } />
    <Comp.Access.AdminRoute path={Paths.AdminPage.Edit + "/:id"} render={(routeProps) => <Cont.AdminPage.Edit { ...routeProps} /> } />

    {/* Admin tags */}
    <Comp.Access.AdminRoute path={Paths.AdminTag.List} render={(routeProps) => <Cont.AdminTag.ListTags { ...routeProps } /> } />
</Switch>;

const routes = <Switch>
    {/*** Public routes ***/}
    <Route exact path={Paths.Home} component={Cont.Page.Home} />
    <Route exact path={Paths.AccessDenied} component={Cont.Account.AccessDenied} />
    <Route path={Paths.Account.Logout} render={(routeProps) => <Cont.Account.UserLogout />} />

    {/* Abstracts */}
    <Comp.Access.LoginRoute path={Paths.Abstracts.Compose + "/:eventId/:guid/:step"} component={Cont.Abstracts.Composer} />
    <Comp.Access.LoginRoute path={Paths.Abstracts.Confirmation + "/:guid"} component={Cont.Abstracts.Confirmation} />

    {/* Account */}
    <Route exact path={Paths.Account.CreateAccount} component={Cont.Account.CreateAccount} />

    {/* Career center */}
    <Route exact path={Paths.CareerCenter.Landing} component={Cont.CareerCenter.Landing} />
    <Route exact path={Paths.CareerCenter.JobDirectory} component={Cont.CareerCenter.JobDirectory} />
    <Route exact path={Paths.CareerCenter.Job.Details + ":slug"} component={Cont.CareerCenter.JobDetails} />
    <Route exact path={Paths.CareerCenter.ResumeDirectory} component={Cont.CareerCenter.ResumeDirectory} />
    <Route exact path={Paths.CareerCenter.Resume.Details + ":slug"} component={Cont.CareerCenter.ResumeDetails} />
    {/* Career center (posting) */}
    <Comp.Access.LoginRoute exact path={Paths.CareerCenter.Job.Post + "/:guid?"} component={Cont.CareerCenter.PostJob} />
    <Comp.Access.LoginRoute exact path={Paths.CareerCenter.Job.Review + "/:guid"} component={Cont.CareerCenter.ReviewJob} />
    <Comp.Access.LoginRoute exact path={Paths.CareerCenter.Job.Confirmation + "/:guid"} component={Cont.CareerCenter.JobConfirmation} />
    <Comp.Access.LoginRoute exact path={Paths.CareerCenter.Resume.Post + "/:guid?"} component={Cont.CareerCenter.PostResume} />
    <Comp.Access.LoginRoute exact path={Paths.CareerCenter.Resume.Review + "/:guid"} component={Cont.CareerCenter.ReviewResume} />
    <Comp.Access.LoginRoute exact path={Paths.CareerCenter.Resume.Confirmation + "/:guid"} component={Cont.CareerCenter.ResumeConfirmation} />

    {/*** User routes ***/}

    {/* User > Account */}
    <Comp.Access.LoginRoute exact path={Paths.User.Account} component={Cont.User.Account} />

    {/* User > Abstracts */}
    <Comp.Access.LoginRoute exact path={Paths.User.Abstracts.UserAbstracts} component={Cont.User.Abstracts.Abstracts} />
    <Comp.Access.LoginRoute exact path={Paths.User.Abstracts.AbstractDetails + "/:guid"} component={Cont.User.Abstracts.Details} />

    {/* User > Abstract Grading */}
    <Comp.Access.LoginRoute exact path={Paths.User.AbstractGrading.Abstracts} component={Cont.User.AbstractGrading.Abstracts} />
    <Comp.Access.LoginRoute exact path={Paths.User.AbstractGrading.Abstracts + "/:guid"} component={Cont.User.AbstractGrading.Details} />

    {/* User > Career center */}
    <Comp.Access.LoginRoute exact path={Paths.User.CareerCenter.Jobs} component={Cont.User.CareerCenter.UserJobs} />
    <Comp.Access.LoginRoute exact path={Paths.User.CareerCenter.EditJob + "/:guid"} component={Cont.User.CareerCenter.EditJob} />
    <Comp.Access.LoginRoute exact path={Paths.User.CareerCenter.Jobs + "/:guid"} component={Cont.User.CareerCenter.JobDetails} />
    <Comp.Access.LoginRoute exact path={Paths.User.CareerCenter.EditResume + "/:guid"} component={Cont.User.CareerCenter.EditResume} />
    <Comp.Access.LoginRoute exact path={Paths.User.CareerCenter.Resumes} component={Cont.User.CareerCenter.UserResumes} />
    <Comp.Access.LoginRoute exact path={Paths.User.CareerCenter.Resumes + "/:guid"} component={Cont.User.CareerCenter.ResumeDetails} />

    {/* User > Financial disclosure */}
    <Comp.Access.LoginRoute exact path={Paths.User.FinancialDisclosureUpdate} component={Cont.User.FinancialDisclosureUpdate} />

    {/* Redirect routes */}
    <Route exact path="/members/login" render={(routeProps) => <Comp.Generic.RedirectWithStatus to={Paths.Account.Login} /> } />

    {/* Catches all paths (to render "static" pages) */}
    <Route path="*" component={Cont.Page.DefaultPage} />
</Switch>;

export const LoginRoute = <Route path={Paths.Account.Login} component={Cont.Account.SignIn} />;
export const PwResetRoute = <Route path={Paths.Account.ResetPassword + "/:guid"} component={Cont.Account.ResetPasswordForm} />;

export const allRoutes = (routes.props.children as Array<React.Component<RouteProps>>)
    .concat(adminRoutes.props.children as Array<React.Component<RouteProps>>)
    .concat([LoginRoute as any])
    .concat([PwResetRoute as any]);

export class AdminRoutes extends React.Component {
    public render() {
        return adminRoutes;
    }
}

export class AppRoutes extends React.Component {
    public render() {
        return routes;
    }
}



// WEBPACK FOOTER //
// ./src/routes/index.tsx